import { operationFiatRoutes } from "./panel/operation-fiat";
import { submitOrderRoutes } from "./panel/submit-order";
import { ticketRoutes } from "./panel/tickets";
import { operationRoutes } from "./panel/operations";
// import { transactionRoute } from "./panel/transaction";
import { accountRoute } from "./panel/account";
import { walletRoutes } from "./panel/wallet";
import { historyRoutes } from "./panel/history";
export const panelRoute = [
  {
    path: "dashboard",
    name: "dashboard",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.dashboard"
    },
    component: () =>
      import(
        /* webpackChunkName: "DashboardPage" */ "@/views/panel/DashboardPage/index"
      )
  },
  {
    path: "fiat",
    name: "fiat",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.perfectMoney.mainTitle"
    },
    component: () =>
      import(
        /* webpackChunkName: "PerfectMoney" */ "@/views/panel/PerfectMoney/index"
      )
  },
  {
    path: "operation-fiat",
    name: "operation-fiat",
    meta: {
      transitionName: "slide"
    },
    component: () =>
      import(
        /* webpackChunkName: "OperationFiat" */ "@/views/panel/OperationFiat/index"
      ),
    children: operationFiatRoutes
  },
  {
    path: "order",
    name: "panel-order",
    meta: { transitionName: "slide", appBarTitle: "pageTitles.order" },
    component: () =>
      import(
        /* webpackChunkName: "OrderPage" */ "@/views/panel/OrderPage/index"
      )
  },
  {
    path: "submit-order",
    name: "order-process",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "order" */ "@/views/panel/OrderProcessPage/index"
      ),
    children: submitOrderRoutes
  },
  {
    path: "wallet",
    name: "wallet",
    redirect: `/wallet/main`,
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.walletOrder"
    },
    component: () =>
      import(/* webpackChunkName: "wallet" */ "@/views/panel/Wallet/index"),
    children: walletRoutes
  },
  {
    path: "tickets",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.tickets.mainTitle"
    },
    component: () =>
      import(
        /* webpackChunkName: "tickets-index" */ "@/views/panel/Tickets/index"
      ),
    children: ticketRoutes
  },
  {
    path: "gifts",
    name: "gifts",
    meta: { transitionName: "slide", appBarTitle: "pageTitles.gifts" },
    component: () =>
      import(/* webpackChunkName: "gifts" */ "@/views/panel/GiftsPage/index")
  },
  {
    path: "referral",
    name: "referral",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.referral"
    },
    component: () =>
      import(/* webpackChunkName: "gifts" */ "@/views/panel/Referral/index")
  },
  {
    path: "prices",
    name: "prices",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "prices" */ "@/views/panel/PricesListPage/index"
      )
  },
  {
    path: "operations",
    name: "operations",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "wallet" */ "@/views/panel/OperationsPage/index"
      ),
    children: operationRoutes
  },
  // {
  //   path: "transaction",
  //   name: "transaction-order",
  //   redirect: `/transaction/deposits`,
  //   meta: {
  //     transitionName: "slide",
  //     appBarTitle: "pageTitles.transactionOrder.deposits"
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "transactionPage" */ "@/views/panel/TransactionsPage/index"
  //     ),
  //   children: transactionRoute
  // },
  {
    path: "account",
    name: "account",
    meta: { transitionName: "slide", appBarTitle: "pageTitles.account" },
    component: () =>
      import(
        /* webpackChunkName: "account" */ "@/views/panel/AccountPage/index"
      ),
    children: accountRoute
  },
  //   Market Merge

  {
    path: "open-orders",
    name: "openOrders",
    meta: {
      transitionName: "slide",
      appBarTitle: "add title to locale"
    },
    component: () =>
      import(
        /* webpackChunkName: "openOrders" */ "@/views/panel/Market/openOrders/index"
      )
  },
  {
    path: "stop-limit-orders",
    name: "stopLimitOrders",
    meta: {
      transitionName: "slide",
      appBarTitle: "حد سود ضرر"
    },
    component: () =>
      import(
        /* webpackChunkName: "StopLimitOrders" */ "@/views/panel/Market/stopLimitOrders/index"
      )
  },
  // {
  //   path: "orders-history",
  //   name: "ordersHistory",
  //   meta: {
  //     transitionName: "slide",
  //     appBarTitle: "تاریخچه سفارشات"
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "OrdersHistory" */ "@/views/panel/Market/ordersHistory/index"
  //     )
  // },
  // {
  //   path: "precondition-orders-history",
  //   name: "preconditionOrdersHistory",
  //   meta: {
  //     transitionName: "slide",
  //     appBarTitle: "تاریخچه حد سود/ضرر"
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "PreconditionOrdersHistory" */ "@/views/panel/Market/PreconditionOrdersHistory/index"
  //     )
  // },
  // {
  //   path: "p2p-transactions",
  //   name: "transactions",
  //   meta: {
  //     transitionName: "slide",
  //     appBarTitle: "تراکنش‌ها"
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "Transactions" */ "@/views/panel/Market/transactions/index"
  //     )
  // },
  // {
  //   path: "assets",
  //   name: "assets",
  //   meta: {
  //     transitionName: "slide",
  //     appBarTitle: "دارایی‌ها"
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "Assets" */ "@/views/panel/Market/assets/index"
  //     )
  // },
  {
    path: "withdraw",
    name: "withdraw",
    meta: {
      transitionName: "slide",
      appBarTitle: "انتقال"
    },
    component: () =>
      import(
        /* webpackChunkName: "Assets" */ "@/views/panel/Market/withdraw/index"
      )
  },
  // {
  //   path: "exchange/:pair?",
  //   name: "exchange",
  //   props: true,
  //   meta: {
  //     transitionName: "slide",
  //     appBarTitle: "معامله"
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "Exchange" */ "@/views/panel/Market/exchange/index.vue"
  //     )
  // },
  // {
  //   path: "m-exchange/:pair?",
  //   name: "m-exchange",
  //   props: true,
  //   meta: {
  //     transitionName: "slide",
  //     appBarTitle: "معامله"
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "Exchange" */ "@/views/panel/Market/mobileExchange/index.vue"
  //     )
  // },
  {
    path: "history",
    name: "history",
    redirect: `/history/orders-history`,
    meta: {
      transitionName: "slide"
    },
    component: () =>
      import(/* webpackChunkName: "wallet" */ "@/views/panel/History/index"),
    children: historyRoutes
  }
];
